module.exports = __webpack_public_path__ + "static/img/btn-1-active.d9c2ea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn-1-active.png
// module id = ZtyD
// module chunks = 0